/* eslint-disable eqeqeq */
import { soapPost } from '../../ajaxSoap'
import { bizTypeMap } from '../../bizTypeMapping'
import { userInfo, wareHouseInfo } from '../../../global'

export var user = {
  userId: userInfo.userCode,
  userName: userInfo.userName,
  belongToGroupId: null,
  belongToGroupName: null
}

export var newUser={
  userId: userInfo.userCode,
  userName: userInfo.userName,
}

export var wareHouse = {
  warehouseNo: wareHouseInfo.warehouseNo,
  orgNo: wareHouseInfo.orgNo,
  distributeNo: wareHouseInfo.distributeNo
}

export const getCommodity = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)

  await soapPost(bizTypeMap.wms_checkstock_getDCCheckList, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const getLPN = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)

  await soapPost(bizTypeMap.wms_checkstock_getLpnCheckList, {
    'requestInfo': requestInfo,
    'user': newUser,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const getOwner = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)

  await soapPost(bizTypeMap.wms_checkstock_getOCCheckList, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const getCsTaskD = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)

  await soapPost(bizTypeMap.wms_checkstock_getSPCheckList, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const getMove = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)

  await soapPost(bizTypeMap.wms_checkstock_getDSCheckList, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const qryGoodsLevelForListByOwner = async (ownerNo) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_getLevelForListByOwner, {
    'requestInfo': ownerNo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const qryOwnerForList = async () => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_getOwnerForList, {
    'requestInfo': '',
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const getMasterTypes = async (common) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_getMasterTypes, {
    'requestInfo': JSON.stringify(common),
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const getArea = async () => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_getArea, {
    'requestInfo': '',
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}
export const getCellAreaToAOS = async (zone) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_getZoneWithOutArStore, {
    'requestInfo': zone,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const getRobotZones = async () => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_getRobotZones, {
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const getAisle = async (aisel) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_getAisle, {
    'requestInfo': aisel,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const saveCheckOrder = async (orderM) => {
  let ret

  await soapPost(bizTypeMap.wms_checkstock_saveCheckOrder, {
    'requestInfo': JSON.stringify(orderM),
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const getCsOrderM = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)

  await soapPost(bizTypeMap.wms_checkstock_getAssignCheckOrders, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const getCsTaskDBycheckNo = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)

  await soapPost(bizTypeMap.wms_checkstock_getCheckTasksByCsOrderId, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

// 查询盘点列表 add by gongbinglai 2019.01.31
export const getCheckStockOrderList = async (checkOrderM) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_getCheckOrders, checkOrderM).done(function (data) {
    ret = data
  })
  return ret
}
// 查询盘点列表 add by gongbinglai 2019.02.19
export const getCheckStockOrderListByPage = async (checkOrderM) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_getCheckOrdersByPage, checkOrderM).done(function (data) {
    ret = data
  })
  return ret
}

// 根据盘点单号获取盘点任务列表
export const getInventoryConfirmList = async (paramBase) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_getCheckTaskConfirm, paramBase).done(function (data) {
    ret = data
  })
  return ret
}

// 动态盘点结束
export const invokeDynConfirmOver = async (paramBase) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_dyn_dynConfirmOver, paramBase, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// 下一盘
export const invokeNextInventory = async (paramBase) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_confirmContinue, paramBase, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}
// 下一盘
export const invokeStaticConfirmOver = async (paramBase) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_sta_confirmOver, paramBase, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

export const assignCheckOrder = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)

  await soapPost(bizTypeMap.wms_checkstock_assignCheckTasks, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

export const queryUsersByGroup = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_queryUserByLogicArea, {
    'requestInfo': newcrete,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const getUnDoneTaskCount = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_getUnDoneTaskCount, {
    'requestInfo': null,
    'user': newcrete,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}
// 公用 返回下拉框数据
export const getCommonCheckboxItems = async (code) => {
  let ret
  let requestInfo = JSON.stringify({ code: code })
  await soapPost(bizTypeMap.wms_checkstock_getMasterTypes, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}
// 分页查询差异记录
export const differenceSelectFy = async (queryBean) => {
  let ret
  let requestInfo = JSON.stringify(queryBean)
  await soapPost(bizTypeMap.wms_checkstock_wsCsDiff_queryCsDiffListPagesByQueryBean, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}
// 对冲页面查询接口
export const queryHedging = async (queryBean) => {
  let ret
  // let requestInfo = JSON.stringify(queryBean)
  await soapPost(bizTypeMap.wms_checkstock_wsCsDiff_queryHedging,queryBean).done(function (data) {
    ret = data
  })
  return ret
}
// 确认对冲
export const submitHedging = async (queryBean) => {
  let ret
  // let requestInfo = JSON.stringify(queryBean)
  await soapPost(bizTypeMap.wms_checkstock_wsCsDiff_submitHedging,queryBean).done(function (data) {
    ret = data
  })
  return ret
}
// 创建盘盈亏单
export const createPlOrder = async (csDiffList) => {
  let ret
  let requestInfo = JSON.stringify(csDiffList)
  let config = {}
  await soapPost(bizTypeMap.wms_checkstock_wsCsDiff_createPlOrder, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}
// 抽盘 获取货主
export const getOwnerForList = async () => {
  let ret
  let requestInfo = JSON.stringify({})
  await soapPost(bizTypeMap.wms_checkstock_getOwnerForList, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}
// 获取 创建维保单货主数据
export const queryRmOwnerList = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.queryRmOwnerList, newcrete).done(function (data) {
    ret = data
  })
  return ret
}

// 创建维保单 取消方法
export const cancelMaintainanceOrder = async (newcrete, config = {}) => {
  let ret
  await soapPost(bizTypeMap.wms_receiving_cancelMaintainanceOrder, newcrete, config).done(function (data) {
    ret = data
  })
  return ret
}

// 创建维保单 确定方法
export const creatingMaintainanceOrder = async (newcrete, config = {}) => {
  let ret
  await soapPost(bizTypeMap.wms_receiving_creatingMaintainanceOrder, newcrete, config).done(function (data) {
    ret = data
  })
  return ret
}

export const getCsP = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.wms_checkstock_wsCsPl_queryCsPlMListPagesByQueryBean, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}
// 关闭差异
export const processCloseDiff = async (paramBase) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_wsCsDiff_closeButton, paramBase, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

export const createAll = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.wms_checkstock_wsCsPl_selectPlOrderById, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const getMasterTypesTwo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_getReasonListByReasonCode, {
    'requestInfo': newcrete,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const application = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.wms_checkstock_wsCsPl_submitCsPlOrder, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

export const canceled = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.wms_checkstock_wsCsPl_cancelCsPlOrder, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

export const by = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.wms_checkstock_wsCsPl_through, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

export const tAllreject = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.wms_checkstock_wsCsPl_rejectAll, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

export const reject = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.wms_checkstock_wsCsPl_rejectCsPlD, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }, { noParseJson: true }).done(function (data) {
    ret = data
  })
  return ret
}

//vas订单操作
export const qryVasStatusForList = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.qryVasStatusForList, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

//vas订单查询
export const qryVasOrderList = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.qryVasOrderList, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}
//查询出库单关联的未完成vas订单
export const queryNotFinishVasListOfOutboundNo = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.queryCommonUnfinishedVasOrderNoList, newcrete).done(function (data) {
    ret = data
  })
  return ret
}
//根据订单号和secondVasType查询vas列表(补打礼品卡等)
export const queryVasList = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.queryVasList,newcrete).done(function (data) {
    ret = data
  })
  return ret
}

export const queryTransferOrderPrintData = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.queryTransferOrderPrintData,newcrete).done(function (data) {
    ret = data
  })
  return ret
}
//vas订单取消
export const cancelVasOrder = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.cancelVasOrder, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}
//vas订单重置
export const resetVasOrder = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.resetVasOrder, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}
// vas订单详情
export const qryVasOrderDetail = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.qryVasOrderDetail, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

// vas订单完成
export const completeVasOrder = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.completeVasOrder, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

// vas订单关闭
export const closeVasOrder = async (params) => {
  let ret
  params.updateUser=userInfo.userCode
  Object.assign(params,wareHouse)
  await soapPost(bizTypeMap.closeVasOrder, params).done(function (data) {
    ret = data
  })
  return ret
}

// vas任务分配
export const qryVasOrderAssignList = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.qryVasOrderAssignList, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

// vas重定位
export const vasReLocate = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.vasReLocate, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

// 获取图片Base64编码
export const getFileBase64String = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.getFileBase64String, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

// 任务分配
export const assignVasTask = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.assignVasTask, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

// vas手工定位详情（组套信息 + 待定位商品明细）
export const queryVasLocateDetail = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.queryVasLocateDetail, newcrete
  ).done(function (data) {
    ret = data
  })
  return ret
}

// vas手工定位整单确认（提交定位记录）
export const saveVasLocateResult = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.saveVasLocateResult, newcrete
  ).done(function (data) {
    ret = data
  })
  return ret
}

// vas手工定位操作：查询可定位库存
export const queryVasAvailableStock = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.queryVasAvailableStock, newcrete
  ).done(function (data) {
    ret = data
  })
  return ret
}

// ***********************************

// 查询循环盘点任务单
export const queryInventoryMs = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.wms_checkstock_cyclInv_queryInventoryMs, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

// 获取差异管理列表信息
export const queryDiffInventoryMs = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.wms_checkstock_cyclInv_queryDiffInventoryMs, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

// 校验差异复核人不能是盘点
export const checkInventoryCycleIsCCWorker = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.wms_check_inventoryCycle_IsCCWorker, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

// 差异核实
export const checkInventoryCycleSetDiffCheckResult = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.wms_check_inventoryCycle_SetDiffCheckResult, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const getInventoryMs = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.inventoryCycle_GetInventoryM, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const getUnTask = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.inventoryCycle_GetUnTask, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const getTaskedQty = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.inventoryCycle_GetTaskedQty, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

// 获取已分配的任务
export const getTasked = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.inventoryCycle_GetTasked, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

//分配盘点任务前校验用户是否可用
export const checkWkNo = async (newcrete) => {
  let ret
  let requestInfo = newcrete
  await soapPost(bizTypeMap.inventoryCycle_CheckWkNo, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

//检查做过此盘点单差异复核的人员不能再做盘点
export const isChecker = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.inventoryCycle_IsChecker, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

//循环盘点一盘人验证
export const getCCWkno = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.inventoryCycle_GetCCWkno, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

//循环盘点二盘人验证
export const getCCWknoSecond = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.inventoryCycle_GetCCWknoSecond, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

//循环盘点任务取消
export const delCCTask = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.inventoryCycle_deleteInventoryTask, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

//创建一盘盘点任务
export const createTaskFromD = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.inventoryCycle_CreateTaskFromD, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

//创建二盘盘点任务
export const createReCheckTask = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.inventoryCycle_CreateReCheckTask, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

//循环盘点 盘点统计明细
export const queryCcReport = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.wms_checkstock_cyclInv_queryCcReport, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

//盘点导出
export const queryCsTaskDetail = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_queryCsTaskDetail, newcrete).done(function (data) {
    ret = data
  })
  return ret
}

//  查询盘点单明细
export const getCheckDetailList = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.wms_checkstock_Cyc_getTaskDetail, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}
// 库存操作查询
export const getStockFrozenInfo = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.wms_checkstock_getStockFrozenInfo, {
    'queryType':0,
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse,
  }).done(function (data) {
    ret = data
  })
  return ret
}
// 库存操作（锁定库存）
export const freezeStock = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.wms_checkstock_freezeStock, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse,
  }).done(function (data) {
    ret = data
  })
  return ret
}
// 库存操作（解锁库存）
export const unfreezeStock = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.wms_checkstock_unfreezeStock, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse,
  }).done(function (data) {
    ret = data
  })
  return ret
}

// 库存操作（批量解锁库存）
export const batchUnfreezeStock = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.wms_checkstock_batchUnfreezeStock, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse,
  }).done(function (data) {
    ret = data
  })
  return ret
}

// 库存操作（批量锁定库存）
export const freezeStockimport = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.freezeStockimport, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse,
  }).done(function (data) {
    ret = data
  })
  return ret
}
// 库存操作（批量解锁库存）
export const unfreezeStockImport = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.unfreezeStockImport, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse,
  }).done(function (data) {
    ret = data
  })
  return ret
}



//  手动创建移库任务-导入商品明细
export const inputManualTask = async (manualTaskQuery) => {
  let ret
  await soapPost(bizTypeMap.inputManualTask, manualTaskQuery).done(function (data) {
    ret = data
  })
  return ret
}

//  手动创建移库任务-校验储源位
export const queryLocationToAOS = async (manualTaskQuery) => {
  let ret
  await soapPost(bizTypeMap.queryLocationToAOS, manualTaskQuery).done(function (data) {
    ret = data
  })
  return ret
}

//  手动创建移库任务-保存移库任务
export const saveManualTask = async (taskList) => {
  let ret
  await soapPost(bizTypeMap.saveManualTask, taskList).done(function (data) {
    ret = data
  })
  return ret
}

//  移库任务分配-查询
export const queryTaskList = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.queryTaskList, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

//  移库任务分配-删除
export const deleteTask = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.deleteTask, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

//  移库任务分配-分配
export const taskAssign = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.taskAssign, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 货权转移-获取任务下已有的货主
export const getTaskOwner = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.getTaskOwner, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 货权转移-获取操作人
export const getDoWorkerOrder = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.getDoWorkerOrder, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 货权转移-获取分配任务分页列表
export const getTaskForPage = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.getTaskForPage, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 货权转移-获取任务明细
export const getOrderDetailList = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.getOrderDetailList, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 货权转移-自动定位
export const repointLocate = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.repointLocate, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 货权转移-任务分配
export const assignChangeOrderTask = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.assignChangeOrderTask, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

//货权转移-取消
export const receiveCancelChangeMessage = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.receiveCancelChangeMessage, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

//查询商品可用库存信息接口
export const stockQueryQueryStock = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.stockQueryQueryStock, queryBean).done(function (data) {
    ret = data
  })
  return ret
}
//查询商品可用库存信息接口
export const qryItemBaseForObj = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.qryItemBaseForObj, queryBean).done(function (data) {
    ret = data
  })
  return ret
}
// 维保任务生成
export  const createTsRM = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.wms_createTsRM, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

//VAS创建接口
export const createVASByWMS = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.createVASByWMS, queryBean).done(function (data) {
    ret = data
  })
  return ret
}
// 维保列表-查询
export  const queryTsRM = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.wms_queryTsRM, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 维保列表-查询
export  const queryTsRMList = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.wms_queryTsRMList, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 维保列表-待收货完成查询
export  const queryIbRMListForPage = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.wms_queryIbRMListForPage, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 维保列表页-查看
export  const queryTsRMDRDetail = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.wms_queryTsRMDRDetail, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 维保结果录入-明细
export  const queryTsRMDetail = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.wms_queryTsRMDetail, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 维保操作明细展示接口
export  const queryTsRMRDDetail = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.wms_queryTsRMRDDetail, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 维保结果录入
export  const saveTsRMResult = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.wms_saveTsRMResult, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 维保-发货
export  const rmShip = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.wms_rmShip, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 维保-取消发货
export  const rmShipCancel = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.wms_rmShipCancel, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 维保-关单
export  const closeRm = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.wms_closeRm, queryBean).done(function (data) {
    ret = data
  })
  return ret
}
// 打印维保面签
export  const printRmLabel = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.wms_print_rmLabel, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 货权转移-明细批量查询
export const getOwnerChangeGoodsList = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.getOwnerChangeGoodsList, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

export const getLotNoByStock = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.getLotNoByStock, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 维保上传信息保存
export const uploadTsRmFile = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.uploadTsRmFile, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 维保上传信息查询
export const queryTsRmFileByTaskNo = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.queryTsRmFileByTaskNo, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 获取用户信息
export const getEmployeeInfo = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.getEmployeeInfo, queryBean).done(function (data) {
    ret = data
  })
  return ret
}
// 批量取消
export const batchCancelCheckOrder = async (checkOrderM) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_batchCancelCheckOrder, checkOrderM).done(function (data) {
    ret = data
  })
  return ret
}
// 批量转移
export const batchTransCheckOrder = async (checkOrderM) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_batchTransCheckOrder, checkOrderM).done(function (data) {
    ret = data
  })
  return ret
}
// 获取
export const getCheckOrdersExt = async (checkOrderM) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_getCheckOrdersExt, checkOrderM).done(function (data) {
    ret = data
  })
  return ret
}
export const getDiffDetail = async (queryBean) => {
  let ret
  let requestInfo = JSON.stringify(queryBean)
  await soapPost(bizTypeMap.getDiffDetail, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const minionTaskAssign = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.minionTaskAssign, queryBean).done(function (data) {
    ret = data
  })
  return ret
}
export const minionQueryTask = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.minionQueryTask, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

export const minionsFinishWaveTask = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.minionsFinishWaveTask, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

export const moveDownDetailPage = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.move_down_detail_page, queryBean).done(function (data) {
    ret = data
  })
  return ret
}
export const moveUpDetailPage = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.move_up_detail_page, queryBean).done(function (data) {
    ret = data
  })
  return ret
}
export const moveDownExceptionPage = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.move_down_exception_page, queryBean).done(function (data) {
    ret = data
  })
  return ret
}
export const moveUpExceptionPage = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.move_up_exception_page, queryBean).done(function (data) {
    ret = data
  })
  return ret
}
export const moveDownTaskPage = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.move_down_task_page, queryBean).done(function (data) {
    ret = data
  })
  return ret
}
export const moveUpTaskPage = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.move_up_task_page, queryBean).done(function (data) {
    ret = data
  })
  return ret
}
export const moveDownTaskDetail = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.move_down_task_detail, queryBean).done(function (data) {
    ret = data
  })
  return ret
}
export const moveUpTaskDetail = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.move_up_task_detail, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 盘点明细列表
export const checkstockSuDetailPage = async (checkOrderM) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_su_detailPage, checkOrderM).done(function (data) {
    ret = data
  })
  return ret
}

// 盘点异常列表
export const checkStockSuDiffDetailPage = async (checkOrderM) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_su_diff_detailPage, checkOrderM).done(function (data) {
    ret = data
  })
  return ret
}

// 盘点详情列表
export const checkstockGetSuCheckTasksByCsOrderId = async (checkOrderM) => {
  let ret
  await soapPost(bizTypeMap.wms_checkstock_getSuCheckTasksByCsOrderId, checkOrderM).done(function (data) {
    ret = data
  })
  return ret
}

// // 盘点详情列表
// export const moveUpTaskAssign = async (checkOrderM) => {
//   let ret
//   await soapPost(bizTypeMap.move_up_task_assign, checkOrderM).done(function (data) {
//     ret = data
//   })
//   return ret
// }

// 移库任务查询
export const queryMovePickingTask = async (checkOrderM) => {
  let ret
  await soapPost(bizTypeMap.queryMovePickingTask, checkOrderM).done(function (data) {
    ret = data
  })
  return ret
}

// 移库任务查询
export const saveMovePickingTask = async (checkOrderM) => {
  let ret
  await soapPost(bizTypeMap.saveMovePickingTask, checkOrderM).done(function (data) {
    ret = data
  })
  return ret
}
// 移库任务查询
export const moveUpTaskAssign = async (checkOrderM) => {
  let ret
  await soapPost(bizTypeMap.moveUpTaskAssign, checkOrderM).done(function (data) {
    ret = data
  })
  return ret
}
// 移库任务查询
export const moveDownTaskAssign = async (checkOrderM) => {
  let ret
  await soapPost(bizTypeMap.moveDownTaskAssign, checkOrderM).done(function (data) {
    ret = data
  })
  return ret
}
export const moveDownTaskDelete = async (checkOrderM) => {
  let ret
  await soapPost(bizTypeMap.moveDownTaskDelete, checkOrderM).done(function (data) {
    ret = data
  })
  return ret
}

// 获取盘点任务进度信息
export const getInventoryTaskProcess = async (newcrete) => {
  let ret
  let requestInfo = JSON.stringify(newcrete)
  await soapPost(bizTypeMap.inventoryCycle_getInventoryTaskProcess, {
    'requestInfo': requestInfo,
    'user': user,
    'wareHouseInfo': wareHouse
  }).done(function (data) {
    ret = data
  })
  return ret
}

export const reassignCCWkno = async (newcrete) => {
  let ret
  await soapPost(bizTypeMap.inventoryCycle_reassignCCWkno, newcrete).done(function (data) {
    ret = data
  })
  return ret
}

// 扫描容器获取加工任务
export const obtainProcessTaskByContainer = async (params) => {
  let ret
  await soapPost(bizTypeMap.obtainProcessTaskByContainer, params).done(function (data) {
    ret = data
  })
  return ret
  // return new Promise((resolve) => {

  //   setTimeout(() => {
  //     resolve({
  //     "completeKitQty": 3,
  //     "containerNo": "CT1786538066060001",
  //     "distributeNo": "1",
  //     "goodsItems": [
  //         {
  //             "containerNo": "CT1786538066060002",
  //             "createTime": "2026-08-12 19:34:26",
  //             "createUser": "system",
  //             "distributeNo": "1",
  //             "goodsName": "mjytest260801-2-n",
  //             "goodsAliasCode": "goodsAliasCode",
  //             "goodsBarcode": "goodsBarcode",
  //             "goodsNo": "FG0012539031P",
  //             "id": 17,
  //             "imagePath":"https://img10.360buyimg.com/imagetools/jfs/t1/414366/26/12452/1103684/69d62613F87c5de2b/03e65004840bad4d.png",
  //             "operateQty": 0,
  //             "orgNo": "1",
  //             "packingQty": 5,
  //             "packingUnit": "each",
  //             "perKitQuantity": 1,
  //             "pickedQty": 5,
  //             operateQty: 3,
  //             "pickingTaskNo": "PT1786538066060",
  //             "productLevel": "100",
  //             "status": 1,
  //             "updateTime": "2026-08-12 19:34:26",
  //             "updateUser": "system",
  //             "vasLocateDId": 116,
  //             "vasOrderNo": "VASA20260812005",
  //             "version": 0,
  //             "warehouseNo": "C0000000977",
  //             "yn": 0
  //         },
  //         {
  //             "containerNo": "CT1786538066060001",
  //             "createTime": "2026-08-12 19:34:26",
  //             "createUser": "system",
  //             "distributeNo": "1",
  //             "goodsName": "PTSP_072401",
  //             "goodsNo": "FG0012461747P",
  //             "id": 16,
  //             lotNo:'-1',
  //             "operateQty": 0,
  //             "orgNo": "1",
  //             "packingQty": 5,
  //             "packingUnit": "each",
  //             "perKitQuantity": 1,
  //               "pickedQty": 5,
  //             operateQty: 3,
  //             "pickingTaskNo": "PT1786538066060",
  //             "productLevel": "100",
  //             "status": 2,
  //             "updateTime": "2026-08-13 09:42:23",
  //             "updateUser": "jdhk_VNWhuidwHRAX",
  //             "vasLocateDId": 115,
  //             "vasOrderNo": "VASA20260812005",
  //             "version": 1,
  //             "warehouseNo": "C0000000977",
  //             "yn": 0
  //         }
  //     ],
  //     "operator": "jdhk_VNWhuidwHRAX",
  //     "orgNo": "1",
  //     "unCompleteContainerList": [
  //     ],
  //     "vasOrderInfo": {
  //         "kitConsumableCode": 'HCK',
  //         "bizType": 0,
  //         "createTime": "2026-08-12 20:26:07",
  //         "createUser": "JD_FOP",
  //         "distributeNo": "1",
  //         "id": 9573,
  //         "kitDiagramFile": 'https://img10.360buyimg.com/imagetools/jfs/t1/414366/26/12452/1103684/69d62613F87c5de2b/03e65004840bad4d.png',
  //         "kitGoodsName": "PTSP_072402",
  //         "kitGoodsNo": "FG0012460354P",
  //         "kitLabelFile": "https://file-center-sg.jd.com/api/outfile/download/vas-img/85AE0AB9-F56E-4EB3-9DD9-8F3F1D5FEF10.txt?Expires=1816862564&AccessKey=yYGKncs7aUj9hVNX&Signature=6iNArf7x6Q81RHai6slXSaMO1io%3D",
  //         "kitQuantity": 5,
  //         "locateFlag": 1,
  //         "messageId": "dcd84a1e-2293-4119-afb7-20260812010005",
  //         "newFlag": "1",
  //         "optStatus": 5,
  //         "orgNo": "1",
  //         "outVasOrderNo": "combo-310093844411211",
  //         "ownerName": "北京多快好科技有限公司A",
  //         "ownerNo": "FBU200000011700001P",
  //         "processCode": "11201",
  //         "processTarget": 2,
  //         "productCode": "PD757674P",
  //         "totalQty": 5,
  //         "updateTime": "2026-08-12 19:29:12",
  //         "updateUser": "liuyang872",
  //         "vasApproveFlag": 1,
  //         "vasCode": "33",
  //         "vasOrderNo": "VASA20260812005",
  //         "version": 1786537567700,
  //         "warehouseNo": "C0000000977",
  //         "yn": 0
  //     },
  //     "warehouseNo": "C0000000977"
  // })
  //   },1000)
  // })
}

//任务提交
export const processTask = async (params) => {
  let ret
  await soapPost(bizTypeMap.processTask, params).done(function (data) {
   ret = data
  })
  return ret
}

// 备件库申请单分页查询
export const querySpareOrderByPage = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.wms_spare_querySpareOrderByPage, queryBean).done(function (data) {
    ret = data
  })
  return ret
}


//完成容器
export const competeTask = async (params) => {
  let ret
  await soapPost(bizTypeMap.competeTask, params).done(function (data) {
      ret = data
  })
  return ret
}

// 备件库申请单-储区非锁定库存查询
export const querySpareStock = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.wms_spare_querySpareStock, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

//刻字打印
export const queryPrintVasInfo = async (params) => {
  let ret
  await soapPost(bizTypeMap.queryPrintVasInfo, params).done(function (data) {
    ret = data
  })
  return ret
}
// 备件库申请单-商品明细查询
export const querySpareOrderDList = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.wms_spare_querySpareOrderDList, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 备件库申请单-创建
export const createSpareOrder = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.wms_spare_createSpareOrder, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 文件导入日志分页查询
export const queryFileImportByPage = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.queryFileImportByPage, queryBean).done(function (data) {
    ret = data
  })
  return ret
}

// 文件导入-保存导入记录
export const saveFileImport = async (queryBean) => {
  let ret
  await soapPost(bizTypeMap.saveFileImport, queryBean).done(function (data) {
    ret = data
  })
  return ret
}


